module.exports = __webpack_public_path__ + "static/mc-didonesque-roman-780727fc5fa3bb837214387ec7cf3947.woff2";